import {
  ID,
  Relationship,
  SortingMode,
  Tag,
  Task,
  TaskListTreeItem,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { buildTagTree } from '@griply/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRelationshipsMap } from 'shared/hooks/use-relationships';

export type Options = {
  tasks: Task[];
  tags: Tag[];
  relationships: Relationship[];
  customOrder?: Record<ID, ID[]>;
  sortingMode?: SortingMode | null;
  today: Timestamp;
  weekStartsOn: WeekDays;
  showEmptyGroups?: boolean;
  hideNewTaskRow?: boolean;
};

export const useTagTree = ({
  tasks,
  tags,
  relationships,
  customOrder,
  sortingMode,
  today,
  weekStartsOn,
  showEmptyGroups,
  hideNewTaskRow,
}: Options) => {
  const { t } = useTranslation();
  const relationshipsMap = useRelationshipsMap(relationships);
  const untaggedLabel = t('general.sections.untagged.title');

  return useMemo<Record<ID, TaskListTreeItem>>(
    () =>
      buildTagTree({
        tasks,
        tags,
        relationshipsMap,
        customOrder,
        sortingMode,
        today,
        weekStartsOn,
        showEmptyGroups,
        hideNewTaskRow,
        untaggedLabel,
        rootLabel: 'Root',
        newTaskLabel: 'New Task',
      }),
    [
      customOrder,
      relationshipsMap,
      sortingMode,
      tags,
      tasks,
      today,
      weekStartsOn,
      showEmptyGroups,
      hideNewTaskRow,
      untaggedLabel,
    ],
  );
};
